import React from "react";

import styles from "../../../styles/integrations.module.scss";

import { IntegrationsAPI } from "../../../providers/IntegrationsAPI";
import { EnvironmentStorage } from "../../tools/EnvironmentStorage";
import { Loading } from "../../components/Loading";
import { ConsentStep } from "../MottuDelivery/ConsentStep";
import { RequestPermissionStep } from "../MottuDelivery/RequestPermissionStep";
import { PickupAddressStep } from "../MottuDelivery/PickupAddressStep";
import { CompleteStep } from "../MottuDelivery/CompleteStep";
import { Drawer } from "../../components/Drawer";
import { Context } from "pages/Integrations";

const Steps = {
  CREDENTIALS: "credentials",
  PICKUP_ADDRESS: "pickup_address",
  COMPLETE: "complete",
};

export default class MottuDrawer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      step: Steps.CREDENTIALS,
      loadingPage: true,
      loadingStep: false,
      environment: EnvironmentStorage.getEnvironment(),
      account: {
        active: false,
        webhookUrl: '',
      },
      brandAccount: null,
      authorizationCode: null,
      verification: {},
      editing: false,
    };
  }

  componentDidMount() {
    this.loadAccount();
  }

  async loadAccount() {
    const { environment } = this.state;

    const accountResponse = await IntegrationsAPI.getMottuAccount(
      environment.id
    );
    const account = accountResponse.getData({});

    let brandAccountResponse = null;
    let brandAccount = null;
    if (environment?.brand?.id) {
        brandAccountResponse = await IntegrationsAPI.getMottuAccount(
            environment.brand.id
        );
        brandAccount = brandAccountResponse.getData({});
        this.setState({ brandAccount });
    }

    let newStep = Steps.CREDENTIALS;
    if (accountResponse.getErrors([]).length === 0) {
        this.isEdition(true);
      if (
        account.storeId ||
        account.pickupAddress ||
        account.apiToken
      ) {
        newStep = Steps.COMPLETE;
      } else {
        if ((!brandAccount?.apiToken || !brandAccount?.active) && !account?.apiToken)
            newStep = Steps.CREDENTIALS;
        else
            newStep = Steps.PICKUP_ADDRESS;
      }
    } else {
        if (environment.type === "BRAND") {
            newStep = Steps.CREDENTIALS;
        } else {
            if (!brandAccount?.apiToken || !brandAccount?.active)
                newStep = Steps.CREDENTIALS;
            else
                newStep = Steps.PICKUP_ADDRESS;
        }
    }

    this.setState({
      step: newStep,
      account,
      loadingPage: false,
    });
  }

  async requestPermission(apiToken, storeId, showTrackingUrl, cancelationControl, allowPreview, allowOfflinePayment) {
    const { environment, account, editing } = this.state;
    const { active, pickupAddress } = account;

    this.setState({
      loadingStep: true,
    });
    let updateResponse = null;

    const configs = [
      environment.id,
      active === undefined ? false : active,
      storeId,
      pickupAddress,
      showTrackingUrl,
      cancelationControl,
      allowPreview,
      allowOfflinePayment,
      apiToken
    ];

    if (editing === true) {
        updateResponse = await IntegrationsAPI.setMottuAccount(...configs);
    } else {
        updateResponse = await IntegrationsAPI.createMottuAccount(...configs);
    }

    this.setState({
      loadingStep: false,
    });

    if (updateResponse.getErrors([]).length > 0) {
      alert({ text: updateResponse.getErrors()[0], buttonText: "Ok" });
      return false;
    }
    await this.loadAccount();
  }

  async updateAccount({
    active,
    storeId,
    pickupAddress,
    showTrackingUrl,
    cancelationControl,
    allowPreview,
    allowOfflinePayment,
    apiToken,
  }) {
    const { environment, editing } = this.state;

    let updateResponse = null;

    const configs = [
      environment.id,
      active === undefined ? false : active,
      storeId,
      pickupAddress,
      showTrackingUrl,
      cancelationControl,
      allowPreview,
      allowOfflinePayment,
      apiToken
    ]

    if (editing === true) {
        updateResponse = await IntegrationsAPI.setMottuAccount(...configs);
    } else {
        updateResponse = await IntegrationsAPI.createMottuAccount(...configs);
    }

    if (updateResponse.getErrors([]).length > 0) {
      alert({ text: updateResponse.getErrors()[0], buttonText: "Ok" });
      return false;
    }

    if (editing) {
        this.setState((prevState) => ({
            account: {
              ...prevState.account,
              active,
              storeId,
              pickupAddress,
              apiToken,
              showTrackingUrl,
              cancelationControl,
              allowPreview,
              allowOfflinePayment,
            },
        }));
    } else {
        await this.loadAccount();
    }

    return true;
  }

  async changeStep(newStep) {
    this.setState({
      step: newStep,
    });
  }

  async isEdition(editing) {
    this.setState({
        editing,
    });
  }

  async toggleActive() {
    const { account } = this.state;
    const { pickupAddress, storeId, apiToken, active, showTrackingUrl, cancelationControl, allowPreview, allowOfflinePayment } =
      account;
    this.setState({ loadingStep: true });
    await this.isEdition(true);
    await this.updateAccount({
      active: !active,
      pickupAddress,
      storeId,
      showTrackingUrl,
      cancelationControl,
      allowPreview,
      allowOfflinePayment,
      apiToken,
    });
    this.setState({ loadingStep: false });
  }

  async updateAddress({ pickupAddress, storeId, showTrackingUrl, cancelationControl, allowPreview, allowOfflinePayment }) {
    const { account } = this.state;
    const { active } = account;
    this.setState({ loadingStep: true });
    const updateSuccess = await this.updateAccount({
      active: active === undefined ? false : active,
      pickupAddress: pickupAddress || null,
      storeId,
      showTrackingUrl,
      cancelationControl,
      allowPreview,
      allowOfflinePayment,
    });
    if (updateSuccess) {
      this.setState({ loadingStep: false, step: Steps.COMPLETE });
    }
    return updateSuccess;
  }

  render() {
    const { loadingPage, loadingStep, step, account, brandAccount, environment } = this.state;
    const { visible, onClose } = this.props;

    return (
      <Drawer visible={visible} onClose={onClose} closeInFade title="Mottu">
        <Context />
        
        {loadingPage && (
          <div className={styles.loading}>
            <Loading />
          </div>
        )}

        {!loadingPage && (
          <div className={styles.scrollContainer}>
            {step === Steps.CREDENTIALS && (
              <RequestPermissionStep
                loading={loadingStep}
                account={account}
                onConfirm={async (apiToken, storeId, showTrackingUrl, cancelationControl, allowPreview, allowOfflinePayment) =>
                  await this.requestPermission(apiToken, storeId, showTrackingUrl, cancelationControl, allowPreview, allowOfflinePayment)
                }
              />
            )}

            {step === Steps.PICKUP_ADDRESS && (
              <PickupAddressStep
                loading={loadingStep}
                account={account}
                environment={environment}
                onConfirm={async ({
                  pickupAddress,
                  storeId,
                  showTrackingUrl,
                  cancelationControl,
                  allowPreview,
                  allowOfflinePayment,
                }) =>
                  await this.updateAddress({
                    pickupAddress,
                    storeId,
                    showTrackingUrl,
                    cancelationControl,
                    allowPreview,
                    allowOfflinePayment
                  })
                }
              />
            )}

            {step === Steps.COMPLETE && (
              <CompleteStep
                account={account}
                brandAccount={brandAccount}
                loading={loadingStep}
                isBrand={environment?.type === "BRAND"}
                onChangeStatus={() => this.toggleActive()}
                onEditPickup={async () => { await this.isEdition(true); this.changeStep(Steps.PICKUP_ADDRESS)} }
                onEditCredentials={async () => { await this.isEdition(true); this.changeStep(Steps.CREDENTIALS)} }
              />
            )}
          </div>
        )}
      </Drawer>
    );
  }
}
